module.exports = __webpack_public_path__ + "img/recentdoc.7311a19d.svg";